import { VisitMethods } from '../constants/VisitMethods';

export const ONLINE_VISIT_LABEL_SUFFIX = '(Online)';

/**
 * Appends the "(Online)" suffix to a visit-type label for asynchronous (online) visits,
 * e.g. "Addiction treatment" -> "Addiction treatment (Online)". Live visits are unchanged.
 */
export const getVisitTypeLabel = (visitTypeName?: string, method?: string): string => {
  if (!visitTypeName) {
    return visitTypeName ?? '';
  }

  return method === VisitMethods.ASYNCHRONOUS
    ? `${visitTypeName} ${ONLINE_VISIT_LABEL_SUFFIX}`
    : visitTypeName;
};
